// extracted by mini-css-extract-plugin
module.exports = {"target":"DhOBJI","targetLink":"OPECp_","icon":"AvyBKk"};